$(function () {
    var count = 0;
    var $cells = $('#output .digit-cell');
    var $branch = $('#branch_id');
    var $branchRow = $('.branch-row');
    var $keypad = $('#keypad');
    var $submit = $('#check_In');

    /* ───────────────────────────────────────────────────────────────
     * PR-AQ5(2026-05-23): 지점 선택 게이트 — 지점 미선택 시
     *   - 번호 입력 차단 + skm.warning 알림
     *   - 채점하러가기 버튼 비활성화
     *   - keypad 시각적 잠금(.is-locked) + branch-row pulse(.is-empty)
     * ─────────────────────────────────────────────────────────────── */
    function isBranchSelected() {
        return $branch.val() !== '' && $branch.val() != null;
    }

    function updateSubmitState() {
        $submit.prop('disabled', !(isBranchSelected() && count === 4));
    }

    function updateBranchGate() {
        var empty = !isBranchSelected();
        $branchRow.toggleClass('is-empty', empty);
        $keypad.toggleClass('is-locked', empty);
        updateSubmitState();
    }

    function warnRequireBranch() {
        $branch.focus();
        $branchRow.addClass('is-empty');
        if (window.skm && skm.warning) {
            skm.warning('지점 선택 필요', { text: '먼저 지점을 선택해주세요!' });
        } else {
            alert('먼저 지점을 선택해주세요!');
        }
    }

    function renderCells() {
        $cells.each(function (i) {
            var v = $('#num' + i).val();
            if (v !== '' && v != null) {
                $(this).text(v).addClass('is-filled');
            } else {
                $(this).text('').removeClass('is-filled');
            }
        });
        updateSubmitState();
    }

    function pushDigit(num) {
        if (count >= 4) return;
        $('#num' + count).val(num);
        count++;
        renderCells();
    }

    function popDigit() {
        if (count <= 0) return;
        count--;
        $('#num' + count).val('');
        renderCells();
    }

    function clearAll() {
        count = 0;
        for (var i = 0; i < 4; i++) $('#num' + i).val('');
        renderCells();
    }

    // 데스크톱 click + 모바일 touchstart 양쪽 바인딩 (한 동작당 1회만 실행)
    // touchstart 가 발동하면 직후 click 은 무시 (300ms dedup).
    var lastTouchAt = 0;
    function bindKey($el, handler) {
        $el.on('touchstart', function (e) {
            e.preventDefault();
            lastTouchAt = Date.now();
            handler.call(this, e);
        });
        $el.on('click', function (e) {
            if (Date.now() - lastTouchAt < 350) return;
            handler.call(this, e);
        });
    }

    bindKey($('#keypad .key'), function () {
        var $k = $(this);
        var action = $k.data('action');
        if (action === 'clear') return clearAll();
        if (action === 'back') return popDigit();
        var n = $k.data('num');
        if (n !== undefined && n !== null) {
            // PR-AQ5: 지점 미선택이면 번호 입력 차단 + 안내
            if (!isBranchSelected()) {
                warnRequireBranch();
                return;
            }
            pushDigit(String(n));
        }
    });

    bindKey($submit, function (e) {
        if (e && e.preventDefault) e.preventDefault();
        if ($submit.is(':disabled')) {
            // 비활성 상태에서도 명확한 안내 (지점 미선택 / 번호 미입력)
            if (!isBranchSelected()) { warnRequireBranch(); return; }
            if (count !== 4) {
                skm.error('확인', { text: '출결번호 4자리를 입력해주세요!' });
                return;
            }
            return;
        }
        if ($('#overlay').length) {
            $('#overlay').fadeIn(100);
            window.setTimeout(function () { $('#overlay').fadeOut(3000); }, 2000);
        }
        $('#frm').submit();
    });

    // 키보드 입력 지원 (데스크톱 편의)
    $(document).on('keydown', function (e) {
        if (e.key >= '0' && e.key <= '9') {
            if (!isBranchSelected()) { warnRequireBranch(); return; }
            pushDigit(e.key);
        }
        else if (e.key === 'Backspace') { popDigit(); }
        else if (e.key === 'Enter' && !$submit.is(':disabled')) { $submit.trigger('click'); }
    });

    // 지점 선택 변경 시 게이트 상태 갱신
    $branch.on('change', updateBranchGate);

    /* ───────────────────────────────────────────────────────────────
     * PR-AQ7(2026-05-23): 디자인된 BS5 combo + live-search
     *   - native <select id="branch_id"> 단일 진실원천 보존 (§UI/UX #4)
     *   - 디자인 trigger 버튼 + 검색 panel 오버레이
     *   - 검색: 클라이언트 사이드 substring filter (data-name 기준)
     *   - 항목 선택 → native select.val(id).trigger('change') → AQ5 게이트 자동 갱신
     *   - 키보드: ↓/↑ 이동, Enter 선택, ESC 닫기
     *   - 외부 click 닫기 + Trigger ARIA 상태 갱신
     * ─────────────────────────────────────────────────────────────── */
    var $combo = $('#branchCombo');
    var $trigger = $('#branchComboTrigger');
    var $label = $('#branchComboLabel');
    var $panel = $('#branchComboPanel');
    var $search = $('#branchComboSearch');
    var $list = $('#branchComboList');
    var $emptyMsg = $('#branchComboEmpty');

    function syncLabelFromNative() {
        var v = $branch.val();
        var $opt = $branch.find('option[value="' + (v == null ? '' : v) + '"]');
        var text = ($opt.length && v !== '' && v != null) ? $opt.text().trim() : '지점을 선택해주세요';
        $label.text(text);
        $combo.toggleClass('has-value', !!(v !== '' && v != null));
        // 현재 선택 표시
        $list.find('.skm-combo__item').each(function () {
            var $i = $(this);
            $i.toggleClass('is-selected', String($i.data('value')) === String(v));
        });
    }

    function openPanel() {
        if ($panel.attr('hidden') === undefined || $panel.attr('hidden') === false || $panel.prop('hidden') === false) {
            // 이미 열림 — 검색에 포커스
            $search.trigger('focus');
            return;
        }
        $panel.prop('hidden', false).attr('aria-hidden', 'false');
        $trigger.attr('aria-expanded', 'true');
        $combo.addClass('is-open');
        // 검색 입력 초기화 + 포커스
        $search.val('');
        filterList('');
        window.setTimeout(function () { $search.trigger('focus'); }, 30);
    }

    function closePanel() {
        $panel.prop('hidden', true).attr('aria-hidden', 'true');
        $trigger.attr('aria-expanded', 'false');
        $combo.removeClass('is-open');
    }

    function isPanelOpen() {
        return $combo.hasClass('is-open');
    }

    function filterList(q) {
        q = (q || '').toLowerCase().trim();
        var visible = 0;
        $list.find('.skm-combo__item').each(function () {
            var $i = $(this);
            var name = String($i.data('name') || '').toLowerCase();
            var label = String($i.find('.skm-combo__item-name').text() || '').toLowerCase();
            var hit = (q === '' || name.indexOf(q) !== -1 || label.indexOf(q) !== -1);
            $i.toggleClass('is-hidden', !hit);
            if (hit) visible++;
        });
        $emptyMsg.prop('hidden', visible !== 0);
    }

    function pickItem($item) {
        if (!$item || !$item.length || $item.hasClass('is-hidden')) return;
        var val = String($item.data('value'));
        $branch.val(val).trigger('change');  // → AQ5 updateBranchGate 자동 호출
        syncLabelFromNative();
        closePanel();
        $trigger.trigger('focus');
    }

    function focusNeighbor(direction) {
        var $items = $list.find('.skm-combo__item:not(.is-hidden)');
        if (!$items.length) return;
        var $current = $items.filter('.is-focus');
        var idx = $items.index($current);
        if (idx === -1) {
            idx = (direction > 0) ? 0 : ($items.length - 1);
        } else {
            idx = (idx + direction + $items.length) % $items.length;
        }
        $items.removeClass('is-focus');
        var $next = $items.eq(idx).addClass('is-focus');
        // 스크롤 보정
        var liEl = $next[0];
        if (liEl && liEl.scrollIntoView) {
            liEl.scrollIntoView({ block: 'nearest' });
        }
    }

    // Trigger 클릭 → 열기 / 닫기 토글
    $trigger.on('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (isPanelOpen()) closePanel(); else openPanel();
    });

    // 검색 input → 실시간 필터
    $search.on('input', function () { filterList($(this).val()); });

    // 검색 input 키보드: ↓ 이동, Enter 첫 매칭 선택, ESC 닫기
    $search.on('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); focusNeighbor(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); focusNeighbor(-1); }
        else if (e.key === 'Enter') {
            e.preventDefault();
            var $focused = $list.find('.skm-combo__item.is-focus');
            if (!$focused.length) $focused = $list.find('.skm-combo__item:not(.is-hidden)').first();
            pickItem($focused);
        }
        else if (e.key === 'Escape') { e.preventDefault(); closePanel(); $trigger.trigger('focus'); }
    });

    // 리스트 항목 클릭 → 선택
    $list.on('click', '.skm-combo__item', function (e) {
        e.preventDefault();
        pickItem($(this));
    });

    // 리스트 호버 → focus 표시 동기화
    $list.on('mouseenter', '.skm-combo__item', function () {
        $list.find('.skm-combo__item.is-focus').removeClass('is-focus');
        $(this).addClass('is-focus');
    });

    // Trigger 키보드: Enter/Space/↓ → 열기, ESC → 닫기
    $trigger.on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
            e.preventDefault(); openPanel();
        } else if (e.key === 'Escape' && isPanelOpen()) {
            e.preventDefault(); closePanel();
        }
    });

    // 외부 click → 닫기
    $(document).on('click', function (e) {
        if (!isPanelOpen()) return;
        if ($(e.target).closest('#branchCombo').length === 0) closePanel();
    });

    // 초기 라벨 동기화 (cookie/old 로 선택된 값 반영)
    syncLabelFromNative();

    // 초기 상태
    updateBranchGate();
    renderCells();
});
